import React, { Component } from 'react';
import config from '../../../config';

const DEFAULT_IMAGE =
  'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg';

class FilterCardCarousel extends Component {
  constructor(props) {
    super(props);
    this.carouselRef = React.createRef();
  }

  handleCardClick = (filterValue, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const { onFilterChange, filterIndex, filter } = this.props;

    onFilterChange(
      { filter, filterIndex },
      filterValue ? [filterValue] : []
    );

    setTimeout(() => this.props.onFiltersApplied(), 50);
    setTimeout(() => this.scrollToActive(), 100);
  };

  scrollLeft = () => {
    if (this.carouselRef.current) {
      this.carouselRef.current.scrollBy({
        left: -180,
        behavior: 'smooth'
      });
    }
  };

  scrollRight = () => {
    if (this.carouselRef.current) {
      this.carouselRef.current.scrollBy({
        left: 180,
        behavior: 'smooth'
      });
    }
  };

  scrollToActive = () => {
    if (!this.carouselRef.current) return;

    const activeCard =
      this.carouselRef.current.querySelector('.carousel-card.active');

    if (activeCard) {
      activeCard.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  };

  render() {
    const {
      options = [],
      currentValue = '',
      displayProp,
      imageProp,
      displayName
    } = this.props;

    const cardWidth = 160;

    return (
      <div
        className="filter-card-carousel mb-4"
        style={{ maxWidth: '100%', position: 'relative' }}
      >
        {/* Gradient Label */}
        <div
          style={{
            display: 'inline-block',
            marginBottom: '14px',
            padding: '6px 18px',
            fontSize: '13px',
            fontWeight: 700,
            color: '#fff',
            borderRadius: '999px',
            background:
              'linear-gradient(135deg, #667eea, #764ba2)',
            boxShadow:
              '0 6px 20px rgba(102,126,234,0.35)'
          }}
        >
          {displayName}
        </div>

        {/* Carousel */}
        <div style={{ position: 'relative' }}>
          <div
            ref={this.carouselRef}
            className="carousel-track"
            style={{
              display: 'flex',
              overflowX: 'auto',
              gap: '20px',
              padding: '20px',
              background: '#ffffff',
              borderRadius: '20px',
              boxShadow:
                '0 10px 30px rgba(0,0,0,0.08)',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none'
            }}
          >
            {/* All Card */}
            <div
              className={`carousel-card ${
                !currentValue ? 'active' : ''
              }`}
              style={{
                width: `${cardWidth}px`,
                height: '140px',
                cursor: 'pointer',
                borderRadius: '20px',
                padding: '20px',
                background: !currentValue
                  ? 'linear-gradient(135deg, #667eea, #764ba2)'
                  : '#f8fafc',
                color: !currentValue
                  ? '#fff'
                  : '#334155',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: !currentValue
                  ? '0 16px 40px rgba(102,126,234,0.4)'
                  : '0 10px 25px rgba(0,0,0,0.06)',
                transition: 'all 0.3s ease'
              }}
              onClick={(e) =>
                this.handleCardClick('', e)
              }
            >
              <div
                style={{
                  fontSize: '30px',
                  marginBottom: '10px'
                }}
              >
                <i className="fa fa-th-large" />
              </div>

              <div
                style={{
                  fontSize: '13px',
                  fontWeight: 700,
                  textAlign: 'center'
                }}
              >
                All {displayName}
              </div>
            </div>

            {/* Dynamic Cards */}
            {options.map((item, idx) => {
              const value = item[displayProp];
              const rawImageUrl = item[imageProp];
              let imageUrl = DEFAULT_IMAGE;

              if (rawImageUrl && rawImageUrl.trim() !== '') {
                imageUrl = rawImageUrl.startsWith('http')
                  ? encodeURI(rawImageUrl)
                  : encodeURI(
                      config.assetsBasePath + rawImageUrl
                    );
              }
              const isActive =
                currentValue === value;

              return (
                <div
                  key={`${value}-${idx}`}
                  className={`carousel-card ${
                    isActive ? 'active' : ''
                  }`}
                  style={{
                    width: `${cardWidth}px`,
                    height: '140px',
                    cursor: 'pointer',
                    borderRadius: '20px',
                    padding: '18px',
                    background: isActive
                      ? 'linear-gradient(135deg, #007bff, #00d4ff)'
                      : '#ffffff',
                    color: isActive
                      ? '#fff'
                      : '#1e293b',
                    boxShadow: isActive
                      ? '0 18px 50px rgba(0,123,255,0.4)'
                      : '0 10px 25px rgba(0,0,0,0.08)',
                    border: isActive
                      ? 'none'
                      : '1px solid #e2e8f0',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={(e) =>
                    this.handleCardClick(value, e)
                  }
                >
                  <div
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '16px',
                      overflow: 'hidden',
                      marginBottom: '10px',
                      background: '#f1f5f9',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <img
                      src={imageUrl}
                      alt={value}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = DEFAULT_IMAGE;
                      }}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>

                  <div
                    style={{
                      fontSize: '12.5px',
                      fontWeight: 700,
                      textAlign: 'center',
                      lineHeight: 1.3
                    }}
                  >
                    {value}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Left Arrow */}
          <button
            onClick={this.scrollLeft}
              type="button"
            style={{
              position: 'absolute',
              left: '-10px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: '#fff',
              borderRadius: '50%',
              width: '44px',
              height: '44px',
              border: '1px solid #e2e8f0',
              boxShadow:
                '0 6px 16px rgba(0,0,0,0.1)',
              cursor: 'pointer'
            }}
          >
            <i className="fa fa-chevron-left" />
          </button>

          {/* Right Arrow */}
          <button
            onClick={this.scrollRight}
              type="button"
            style={{
              position: 'absolute',
              right: '-10px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: '#fff',
              borderRadius: '50%',
              width: '44px',
              height: '44px',
              border: '1px solid #e2e8f0',
              boxShadow:
                '0 6px 16px rgba(0,0,0,0.1)',
              cursor: 'pointer'
            }}
          >
            <i className="fa fa-chevron-right" />
          </button>
        </div>
      </div>
    );
  }
}

export default FilterCardCarousel;
